// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"3057a053","175":"04bf71ae","594":"72a56977","628":"1bb10a04","632":"ef207515","649":"371713d9","673":"58314827","677":"c1f33b39","759":"e925ad9f","832":"3adf9148","853":"b351c129","874":"917c4a05","926":"43a75966","974":"bbcd2257"}[chunkId] + ".chunk.js";
};